import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import { N700 } from '@atlaskit/theme/colors';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ICON_STATES, ProductAddedPropsType } from '../../model';
import { ProductIcon } from '../icon';
import { messages, messagesByProductKey } from '../messages';
import {
  CharlieDisplayFontStack,
  ModalAddedSoftwareSubHeading
} from '../styled';

export function ProductAddedView({
  secondaryProductKey
}: ProductAddedPropsType) {
  return (
    <ProductAdded>
      <CheckCircleIcon
        {...{ height: '76px', width: '76px' }}
        label=""
        primaryColor="#00875a"
      />
      <ModalAddedSoftwareSubHeading>
        <FormattedMessage {...messages.youHaveAddedSubHeader} />
      </ModalAddedSoftwareSubHeading>
      <ProductWrapper>
        <ProductIcon
          productKey={secondaryProductKey}
          iconState={ICON_STATES.PRODUCT_ADDED}
        ></ProductIcon>
        <ProductHeading>
          <FormattedMessage
            {...messagesByProductKey[secondaryProductKey].name}
          />
        </ProductHeading>
      </ProductWrapper>
    </ProductAdded>
  );
}

const ProductAdded = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ProductWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductHeading = styled.h2`
  margin: 0 0 0 8px;
  font-size: 32px !important;
  line-height: 32px !important;

  span {
    font-family: ${CharlieDisplayFontStack};
    font-size: 32px;
    line-height: 32px;
    font-weight: 400;
    color: ${N700};
    letter-spacing: 0;
  }
`;
